module.exports = __webpack_public_path__ + "housingStatic/img/bgt.88f8273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgt.png
// module id = 3Yzq
// module chunks = 2